<template lang="html">
 <transition name="move">
  <div class="orderdetails" v-show="showFlag" ref="orderdetails">
        <div class="rating-wrapper">
          <ul>
            <li class="food border-1px">
              <!-- 商品 -->
              <div class="name"><pre>{{ $t('productname') }}</pre></div>
              <!-- 数量 -->
              <div class="price"><pre>{{ $t('cont') }}</pre></div> 
            </li> 
            <li class="food border-1px" v-for="item in orderdetailsobj">
              <div class="name">{{item.ProductName}}</div>
              <div class="price">
                <span>{{item.Quantity}} x {{item.UnitPrice}} €</span>
              </div> 
            </li>
          </ul>
        </div>      
    </div>
  </div>
</transition>
</template>

<script>
import BScroll from 'better-scroll'
import eventbus from '../../common/js/eventbus.js'
export default {
  props: {
    orderdetailsobj: Array
  },
  data() {
    return {
      showFlag: false
    }
  },
  methods: {
    show() {
      this.showFlag = true
      try {
        // if (this.$refs.child1) {
        this.$nextTick(() => {
          if (!this.scroll) {
            this.scroll = new BScroll(this.$refs.orderdetails, {
              click: true
            })
          } else {
            this.scroll.refresh()
          }
        })
        // }
      } catch (error) {
      }
      eventbus.$emit('returnfun', this.hide)
    },
    hide() {
      this.showFlag = false // 隐藏food组件
    },
    isshow() {
      return this.showFlag
    }
  },
  filters: {},
  created() {},
  components: {
  }
}
</script>

<style lang="scss">
@import '../../common/sass/mixin.scss';

.orderdetails {
    position: absolute;
    left: 0;
    top: 0px;
    bottom: 0px;
    z-index: 10;
    width: 100%;
    background: #fff;
    overflow: hidden;
    &.move-enter-active,
    &.move-leave-active {
        // 动画过程
        transition: all 0.5s;
        transform: translate3d(0, 0, 0);
    }
    &.move-enter,
    &.move-leave-to {
        // 动画初始态
        transform: translate3d(100%, 0, 0);
    }
    .avatar {
        flex: 0 0 28px;
        width: 28px;
        height: 28px;
        margin-right: 12px;
        border-radius: 50%;
        overflow: hidden;
        img {
            width: 100%;
        }
    }
    .rating-wrapper {
        padding: 0 18px;
        // .rating-item {
        // display: flex;
        // padding: 18px 0;
        // @include border-1px(rgba(7,17,27,0.1));
        // }
        .food {
            position: relative;
            padding: 12px 0;
            box-sizing: border-box;
            @include border-1px(rgba(7, 17, 27, 0.1));
            height: 48px;
            .name {
                line-height: 24px;
                font-size: 14px;
                color: rgb(7, 17, 27);
                width: 55%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .price {
                position: absolute;
                right: 10px;
                bottom: 12px;
                line-height: 24px;
                font-weight: 14px;
                font-weight: 700;
                color: rgb(240, 20, 20);
            }
            .count {
                position: absolute;
                right: 0px;
                bottom: 12px;
                line-height: 24px;
                font-weight: 14px;
            }
        }
    }

    .content-right {
        background: #00b43c;
        border-radius: 10px;
        position: fixed;
        bottom: 1px;
        z-index: 10;
        width: 98%;
        overflow: hidden;
        height: 43px;
        left: 1%;
        right: 1%;
        .pay {
            line-height: 48px;
            text-align: center;
            font-size: 14px;
            font-weight: 700;
            color: #fff;
            &.not-enough {
                background: #2b333b;
            }
            &.enough {
                background: #00b43c;
                color: #fff;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// orderdetails.vue?4fec39c4